// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"e1076184","703":"3de3b10f"}[chunkId] + ".chunk.js";
};